import { FC } from "react";
import { useLocation } from "react-router-dom";

import { TrackerEntity } from "@ctra/api";
import { Nullable } from "@ctra/utils";
import { MediaQueryDynamicImport } from "@ctra/components";

import { QnAContext, testIds } from "@ask-ida";

/**
 * QnADetails component to render when the search params match on any route
 * @constructor
 */
export const QnADetails: FC = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  /**
   * QnA to pull from the QnAs
   */
  const QnAID: Nullable<TrackerEntity["id"]> = Number(searchParams.get("QnAID"));

  return QnAID ? (
    <div data-testid={testIds.entity.details.wrapper}>
      <MediaQueryDynamicImport mobile={() => import("./Mobile")} desktop={() => import("./Desktop")}>
        {(Details) => (
          <QnAContext.Provider id={QnAID}>
            <Details />
          </QnAContext.Provider>
        )}
      </MediaQueryDynamicImport>
    </div>
  ) : null;
};
